import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import axios from "axios";

interface Member {
  id: string;
  codename: string;
}

interface AssignQuestionnaireModalProps {
  open: boolean;
  onClose: () => void;
  questionnaireId: number;
  onAssign: (memberId: string) => void;
}

const AssignQuestionnaireModal: React.FC<AssignQuestionnaireModalProps> = ({
  open,
  onClose,
  questionnaireId,
  onAssign,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [members, setMembers] = useState<Member[]>([]);
  const [filteredMembers, setFilteredMembers] = useState<Member[]>([]);

  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/members`
        );
        setMembers(response.data);
      } catch (error) {
        console.error("Error fetching members:", error);
      }
    };

    if (open) {
      fetchMembers();
    }
  }, [open]);

  useEffect(() => {
    const filtered = members.filter((member) =>
      member.codename.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredMembers(filtered);
  }, [searchTerm, members]);

  const handleAssign = (memberId: string) => {
    onAssign(memberId);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <Typography variant="h6" component="h2" gutterBottom>
          Assign Questionnaire
        </Typography>
        <TextField
          fullWidth
          label="Search Participants"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          margin="normal"
        />
        <List>
          {filteredMembers.map((member) => (
            <ListItem
              key={member.id}
              button
              onClick={() => handleAssign(member.id)}
            >
              <ListItemText primary={member.codename} />
            </ListItem>
          ))}
        </List>
        <Button onClick={onClose} variant="contained" color="secondary">
          Cancel
        </Button>
      </Box>
    </Modal>
  );
};

export default AssignQuestionnaireModal;
